const STORAGE_KEY = 'amlbotAdClicks';

const DAY_MS = 24 * 60 * 60 * 1000;

const AD_CLICK_TTL_MS = {
  fbclid: 90 * DAY_MS,
  li_fat_id: 30 * DAY_MS,
} as const;

type AdClickParam = keyof typeof AD_CLICK_TTL_MS;

const AD_CLICK_PARAMS: AdClickParam[] = ['fbclid', 'li_fat_id'];

interface AdClick {
  value: string;
  at: number;
}

type AdClicks = Partial<Record<AdClickParam, AdClick>>;

const isAdClick = (value: unknown): value is AdClick =>
  typeof value === 'object' &&
  value !== null &&
  'value' in value &&
  typeof value.value === 'string' &&
  'at' in value &&
  typeof value.at === 'number';

const readStored = (): AdClicks => {
  try {
    const parsed: unknown = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || '{}',
    );
    if (typeof parsed !== 'object' || parsed === null) return {};

    const clicks: AdClicks = {};
    AD_CLICK_PARAMS.forEach((param) => {
      const click: unknown = Reflect.get(parsed, param);
      if (isAdClick(click)) clicks[param] = click;
    });

    return clicks;
  } catch {
    return {};
  }
};

export const rememberAdClicks = (search: string): void => {
  const params = new URLSearchParams(search);
  const landed: AdClicks = {};

  AD_CLICK_PARAMS.forEach((param) => {
    const value = params.get(param);
    if (value) landed[param] = { value, at: Date.now() };
  });

  if (!Object.keys(landed).length) return;

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...readStored(), ...landed }),
    );
  } catch {
    return;
  }
};

const freshAdClick = (param: AdClickParam): AdClick | undefined => {
  const click = readStored()[param];

  return click && Date.now() - click.at < AD_CLICK_TTL_MS[param]
    ? click
    : undefined;
};

export const fbClickIdFromAdClick = (): string => {
  const click = freshAdClick('fbclid');

  return click ? `fb.1.${click.at}.${click.value}` : '';
};

export const linkedInClickIdFromAdClick = (): string =>
  freshAdClick('li_fat_id')?.value || '';
